
import { h, Fragment } from 'preact'; /** @jsx h */


import { type IWiki, Wiki, Paywalled, type IPassage, Passage } from "@pyqml/model";

import { useCacheableQueryProvider } from "../app/CacheableQueryProvider";

import { Layout } from '../components/Layout';
import { Subheader } from '../components/Subheader';
import { List } from '../components/List';
import { Subscribe } from '../components/Subscribe';
import { BlogCover } from '../components/BlogCover';
import { useEnvironment } from '../app/Environment';
import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

//    {pages.map(page => <li><a href={`/${page.pageSlug}`}>{page.title}</a></li>)}

export const Comics = (props) => {
    
    const { baseUrl, imageUrl, subdomain } = useEnvironment();

    
    //href={`${baseUrl}${ROUTES.BLOG_CATEGORY}/${category.categorySlug}`}

    const slug = "comics";
    const { cacheableQuery } = useCacheableQueryProvider();
    
    const [result, refetch, count] = cacheableQuery?.({
        method: "POST",
        endpoint: ROUTES.CLOUDAPI_PUBLIC_GET_PUBLISHED_WIKI,
        queryData: {
            subdomain: subdomain,
            slug: slug,
            draft: props.draft
        },
        reloadOn: [subdomain]
    });

    console.log("Comics", result);

    return (
        <Layout.Stacked>
            {/* <Layout.Fixed>
                category && <Subheader title={`Popular in ${category?.categoryName}`} /> }
                <List.Ordered>
                    {
                        pagesInComics?.map(page => (
                            <List.Item
                                title={ page.title }
                                abstract={ page.abstract }
                                image={ `${imageUrl}/${page.abstractImage}`}
                                linkTo={ `${baseUrl}/${page.slug}` }
                                authorLinkTo="./frank"
                                authorName="Dr. Frank Zickert"
                                publishedAt={ timestampStringInEnglish( page.orig_revision ? page.orig_revision : page.revision ) }
                                readingTime={ page.readingTime ?? undefined }
                            />
                        ))
                    }
                    
                    
                </List.Ordered>
                    
            </Layout.Fixed>*/}
            <Fragment as="Section">
                <BlogCover title="PyQML Comics" subtitle="You get the joke... And you don't get the joke... At the same time..." />
            </Fragment>
            <Layout.Section weight="equal">
            
            </Layout.Section>
            
            <Layout.Section weight="full">

                <Subheader title="Latest" />
                <List.Standard>{
                    result?.data?.passages?.map((passage: IPassage) => (
                        <List.Item
                            title={ passage.title }
                            abstract={ passage.abstract }
                            image={ passage.abstractImage ? `${imageUrl}/${passage.abstractImage}` : undefined}
                            linkTo={ `${baseUrl}${ROUTES.BLOG_WIKI}/${slug}/${passage.slug}` }
                            
                        />
                    ))
                }</List.Standard>
            </Layout.Section>

            <Layout.Section weight="bottom">
                <Subscribe />
            </Layout.Section>


        </Layout.Stacked>
    );
}